/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./product-material-interactive-type.vue?vue&type=template&id=58981ce6&scoped=true&"
import script from "./product-material-interactive-type.vue?vue&type=script&lang=ts&"
export * from "./product-material-interactive-type.vue?vue&type=script&lang=ts&"
import style0 from "./product-material-interactive-type.vue?vue&type=style&index=0&id=58981ce6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58981ce6",
  null
  
)

export default component.exports